import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase/app";

Vue.use(Vuex);

export default new Vuex.Store({
  state: () => ({
    posts: [],
    post: null,
    loader: true,
    message: [],
  }),
  getters: {
    allPost: (state) => state.posts,
    selectPost: (state) => state.post,
    loader: (state) => state.loader,
    message: (state) => state.message,
  },
  mutations: {
    retrievePosts(state, posts) {
      state.posts = posts;
    },
    showPost(state, post) {
      state.post = post;
    },
    loading(state, loader) {
      state.loader = loader;
    },
    addMessage(state, message) {
      state.posts.push(message);
    },
  },
  actions: {
    retrievePosts(ctx) {
      ctx.commit("loading", true);
      firebase.firestore().collection("posts")
        .orderBy("timestamp", "desc")
        .get()
        .then((querySnapshot) => {
          let tempPost = [];
          querySnapshot.forEach((doc) => {
            const data = {
              id: doc.id,
              img: doc.data().img,
              summary: doc.data().summary,
              topTitle: doc.data().topTitle,
              disabled: doc.data().disabled,
              newContent: doc.data().newContent,
            };
            tempPost.push(data);
          });
          ctx.commit("retrievePosts", tempPost);
        })
        .then(() => {
          ctx.commit("loading", false);
        });
    },
    fetchPost(ctx, id) {
      ctx.commit("loading", true);
      firebase.firestore().collection("posts")
        .doc(id)
        .get()
        .then((doc) => {
          ctx.commit("showPost", {
            id: doc.id,
            img: doc.data().img,
            summary: doc.data().summary,
            topTitle: doc.data().topTitle,
            disabled: doc.data().disabled,
            newContent: doc.data().newContent,
          });
        })
        .then(() => {
          ctx.commit("loading", false);
        });
    },
    addMessage(ctx, message) {
      firebase.firestore().collection("messages")
        .add({
          id: message.id,
          company: message.company,
          debt: message.debt,
          state: message.state,
          phone: message.phone,
          email: message.email,
          completed: message.completed,
          time: message.time,
          fullName: `${message.firstName} ${message.lastName}`,
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        })
        .then((docRef) => {
          ctx.commit("addMessage", {
            id: docRef.id,
            company: message.company,
            debt: message.debt,
            state: message.state,
            phone: message.phone,
            email: message.email,
            completed: message.completed,
            time: message.time,
            fullName: `${message.firstName} ${message.lastName}`,
          });
        });
    },
  },
  modules: {},
});
